import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as uploadReducer from "containers/Upload/reducer";
import * as accountsReducer from "containers/Accounts/reducer";
import * as foldersReducer from "containers/Folders/reducer";

import { getProjectID, getProjectDatasets, getCreatingProject } from "containers/ConsultingProjects/reducer";
import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";

import BoomiDatasetLink from "components/View/BoomiDatasetLink";

class DatasetLinkContainer extends React.Component {
  handleFile(event) {
    const { handleFileChange, validateFileExtension, updateIsLinkMode } = this.props;

    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    if (validateFileExtension(file)) {
      updateIsLinkMode(false);
      return handleFileChange(file, event.currentTarget);
    }
  }

  render() {
    return <BoomiDatasetLink handleFileUpload={(e) => this.handleFile(e)} {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  validateFileExtension: (file, extension) => uploadReducer.validateFileExtension(file, extension),
  handleFileChange: (file, target) => dispatch(uploadReducer.handleFileChange(file, target)),
  updateIsLinkMode: (isBoomiLinkMode) => dispatch(viewReducer.updateIsBoomiLinkMode(isBoomiLinkMode)),
  linkDataset: (settings) => dispatch(homeReducer.linkDataset(settings)),
  addMockCatalog: () => dispatch(homeReducer.addMockCatalog())
});

const mapStateToProps = (state, ownProps) => {
  const accounts = accountsReducer.getAccounts(state);
  const selectedFolder = foldersReducer.getSelectedFolder(state);

  return {
    data:
      (getIsMarketplaceDemo() &&
        getProjectID(state) !== null &&
        getCreatingProject(state) &&
        getProjectDatasets(state)) ||
      viewReducer.getDatasets(state, ownProps.blueprintId),
    isLinkMode: viewReducer.getIsBoomiLinkMode(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DatasetLinkContainer);
